/**
* api接口统一管理
  p: 请求参数
*/
import { upload, post } from './http';

/* 爆料 */
// 获取话题列表
export const getTopicList = p => post('/appapi/revelation/tagList', p)
// 获取最新报料列表
export const getReportList =  p => post('/appapi/revelation/index', p)
// 爆料详情
export const getDetails =  p => post('/appapi/revelation/detail', p)
// 话题详情
export const getTopicDetails =  p => post('/appapi/revelation/tag', p)
// 话题下爆料列表
export const getTopicDownList =  p => post('/appapi/revelation/getByTag', p)
// 关键字搜索
export const getSearchList =  p => post('/appapi/revelation/search', p)

/* 晒照 */
// 首页话题列表
export const getTopicList2 = p => post('/appapi/space/getTopic', p)
// 首页精选推荐
export const getCommendList = p => post('/appapi/space/getRecommend', p)
// 最新晒照
export const getNewShowImage = p => post('/appapi/space/newPostslist', p)
// 晒照分类板块儿
export const getShowImagePlate = p => post('/appapi/space/getAllPlate', p)
// 分类板块儿列表
export const getPlateList = p => post('/appapi/space/getSpacePlateList', p)
// 晒照话题列表页
export const getShowImageTopicList = p => post('/appapi/space/getTopic', p)
// 晒照话题详情
export const getShowImageDetails = p => post('/appapi/space/getSpaceTopicList', p)
// 精选推荐页面
export const getCommendPage = p => post('/appapi/space/getRecommendPage', p)
// 晒照图片上传
export const uploadTopicPhoto = p => upload('/app/common/ajaxUpload', p)
// 晒照发布
export const postTopic = p => upload('/app/space/Add', p)

/* 问吧 */
// 首页轮播图
export const getSwiperBanner = p => post('/appapi/ask/focus', p)
// 首页话题列表
export const getAskTopicList = p => post('/appapi/ask/topic', p)
// 首页列表
export const getIndexList = p => post('/appapi/ask/askList', p)


/* 资讯 */
// 首页频道/栏目
export const getInfomation = p => post('/appapi/channel/getList', p)
// 首页列表
export const getInfomationList = p => post('/appapi/channel/getContentList', p)
// 订阅号热门
export const getDyHot = p => post('/appapi/we-media/hot', p)
// 订阅号最新发布
export const getDyNewSend = p => post('/appapi/we-media/latest', p)
// 订阅号全部分类
export const getDyAllType = p => post('/appapi/we-media/contentList', p)
// 我的订阅
export const getMyDy = p => post('/appapi/we-media/myFollow', p)

/* 拍客 */
// 推荐
export const getPattingComment = p => post('/appapi/shortvideo/rec', p)
// 订阅
export const getPattingDy = p => post('/appapi/shortvideo/follow', p)
// 全部
export const getPattingAll = p => post('/appapi/shortvideo/all', p)
// 拍客话题列表
export const getPattingTopicList = p => post('/appapi/shortvideo/more', p)
// 拍客话题详情
export const getPattingTopicDet = p => post('/appapi/shortvideo/tagDetail', p)
export const getPattingTopicDet2 = p => post('appapi/shortvideo/tagList', p)


//话题首页列表页
export const gettopicsApi = p => post('/appapi/circle/gettopicsApi', p)
// 最热话题
export const getHotListpush = p => post('/appapi/circle/getlistpush', p)
//话题详情帖子详情
export const getPostone = p => post('/appapi/circle/postone', p)
//话题详情
export const getTopic = p => post('/appapi/circle/topic', p)
//话题详情帖子列表
export const getGetTopicList = p => post('/appapi/circle/gettopilist', p)
// 话题
export const getNewPostList = p => post('/appapi/circle/postslist', p)

// 其它电台
export const getOtherAudioListApi = p => post("/appapi/bs/otherAudioMore", p)
export const OtherAudioDetailApi = p => post("/appapi/bs/otherRadio", p)
export const ActiListApi = p => post("/appapi/bs/program", p)

// 虚拟电台
// 列表页
export const VirtualDetailApi = p => post("/appapi/bs/virtualRadio", p)

// 评论列表
export const CommentListApi = p => post("/appapi/comment/getList", p)

// 音频
// 列表详情
export const AudioListDetailApi = p => post("/appapi/audio-album/content", p)
// 播放详情(非单音频)
export const AudioDetailInListApi = p => post("/appapi/audio-album/getOneAudio", p)
// 播放详情(单音频)
export const AudioDetailApi = p => post("/appapi/audio/content", p)
// 上一首
export const PrevAudioApi = p => post('/appapi/audio-album/prevAudio', p)
// 下一首
export const NextAudioApi = p => post("/appapi/audio-album/nextAudio", p)

// 单音频详情页
export const SingleAudioDetailApi = p => post("/appapi/audio/content", p)

// 下载app信息
export const downloadInfoApi = p => post("/appapi/news/getShareFocus", p)

// 微信分享
export const getWxShare = p => post(process.env.NODE_ENV == "production" ? '/web/common/getWechatShareParams' : '/api/web/common/getWechatShareParams', p);

// 视频列表
export const videoListApi = p => post('/appapi/video-Album/content', p)

// 视频详情页
export const videoDetailApi = p => post("/appapi/video-Album/getOneVideo", p)
//上个视频
export const prevVideoDetailApi = p => post("/appapi/video-album/prevVideo", p)
//下个视频
export const nextVideoDetailApi = p => post("/appapi/video-album/nextVideo", p)

// 找相似
export const getSimilarApi = p => post('/appapi/audio-album/resemble', p);
